import { useState } from "react";
import assets from "../../assets";

export const AppSettings = () => {
  const [mode, setMode] = useState("simple");
  const [theme, setTheme] = useState("light");
  const [notifications, setNotifications] = useState(true);
  const [language, setLanguage] = useState("English");

  return (
    <div className="preferences">

      {/* Learning Preferences */}
      <section className="section">
        <h3>Learning Preferences</h3>
        <p>Customize how you want to learn and interact with content</p>

        <div className="card">
          <div className="row">
            <span className="label">Explanation Mode</span>

            <div className="mode-switch">
              <button
                className={mode === "simple" ? "active" : ""}
                onClick={() => setMode("simple")}
              >
                ⚡ Simple
              </button>

              <button
                className={mode === "medium" ? "active" : ""}
                onClick={() => setMode("medium")}
              >
                📘 Medium
              </button>

              <button
                className={mode === "story" ? "active" : ""}
                onClick={() => setMode("story")}
              >
                📖 Story Mode
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* App Settings */}
      <section className="section">
        <h3>App Settings</h3>
        <p>Manage your app experience and interface settings</p>

        <div className="card">

          {/* Language */}
          <div className="setting-row">
            <div>
              <h4>App Language</h4>
              <span>Change the language of the interface</span>
            </div>

            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option>English</option>
              <option>Tamil</option>
              <option>Hindi</option>
            </select>
          </div>

          <hr />

          {/* Theme */}
          <div className="setting-row">
            <div>
              <h4>Theme</h4>
              <span>Choose your preferred color scheme</span>
            </div>

            <div className="theme-switch">
              <button
                className={theme === "light" ? "active" : ""}
                onClick={() => setTheme("light")}
              >
                ⚙ Light
              </button>

              <button
                className={theme === "dark" ? "active" : ""}
                onClick={() => setTheme("dark")}
              >
                🌙 Dark
              </button>
            </div>
          </div>

          <hr />

          {/* Notifications */}
          <div className="setting-row">
            <div>
              <h4>Notifications</h4>
              <span>Receive updates about your learning progress</span>
            </div>

            <label className="toggle">
              <input
                type="checkbox"
                checked={notifications}
                onChange={() => setNotifications(!notifications)}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
      </section>
    </div>
  );
};
